import {
  ANALYTICS_PROPERTIES_READY,
  ANALYTICS_READY,
  COHORT_EVENT_INITIALIZED,
  PAGE_VIEW_SENT,
  UPDATE_ANALYTICS_PROPERTIES,
  UPDATE_PARAMETERS,
} from './actionsTypes'

export type AnalyticsState = {
  analyticsReady: boolean
  analyticsPropertiesReady: boolean
  pageViewSent: boolean
  parameters: any
  properties: Record<string, any>
}
const initialState: AnalyticsState = {
  analyticsReady: false,
  analyticsPropertiesReady: false,
  pageViewSent: false,
  parameters: null,
  properties: {},
}
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ANALYTICS_READY:
      return {
        ...state,
        analyticsReady: true,
      }
    case UPDATE_ANALYTICS_PROPERTIES:
      return {
        ...state,
        properties: {
          ...state.properties,
          ...action.payload,
        },
      }
    case ANALYTICS_PROPERTIES_READY:
      return {
        ...state,
        analyticsPropertiesReady: true,
      }
    case UPDATE_PARAMETERS:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          ...action.payload,
        },
      }
    case PAGE_VIEW_SENT:
      return {
        ...state,
        pageViewSent: true,
      }

    // TODO: remove this
    case COHORT_EVENT_INITIALIZED:
      return {
        ...state,
        cohortInitialized: true,
      }
    default:
      return state
  }
}
